/** @format */
import { isObject } from '@toucan/common/services/application/helpers';

export function flattenObject(
    obj = {},
    transformValue = (v: any) => v,
    parentKey = '',
    result = {}
) {
    for (const key in obj) {
        const keyName = parentKey ? `${parentKey}.${key}` : key;
        // @ts-ignore - Element implicitly has an any type - Touch and Change
        if (isObject(obj[key])) {
            // @ts-ignore - Element implicitly has an any type - Touch and Change
            flattenObject(obj[key], transformValue, keyName, result);
        } else {
            // @ts-ignore - Element implicitly has an any type - Touch and Change
            result[keyName] = transformValue(obj[key]);
        }
    }
    return result;
}
